import _ from 'lodash';

import {
    FETCH_ABOUT_PAGE
} from '../actions/Types';

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_ABOUT_PAGE:
            return {...state, ..._.mapKeys(action.payload, 'id')};
        default:
            return state;
    }
}